import styled from "styled-components";
import { Button } from 'reactstrap';

export const AppInfoButton = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: rgba(var(--primeiro), 1);
    background-color: #ffffff;
    border: 2px solid rgba(var(--primeiro), .5);
    transition: all .5s;
`
